import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import WebsiteLayout from "@/layouts/WebsiteLayout.vue";
import AdminLayout from "@/layouts/AdminLayout.vue";
import AppLayout from "@/layouts/AppLayout.vue";
import PrintLayout from "@/layouts/PrintLayout.vue";

import RetrieveUserLogin from "@/core/services/RetrieveUserLogin.vue";
import RetrievedUserLogin from "@/core/services/RetrievedUserLogin.vue";
import Authenticator from "@/core/services/Authenticator.vue";
import AssessmentPrinter from "@/components/global-components/AssessmentPrinter.vue";
import LessonPrinter from "@/components/global-components/LessonPrinter.vue";

import AppLandingView from "@/views/app/AppLandingView.vue";
import AppProfileView from "@/views/app/AppProfileView.vue";
import AppProductOrdersView from "@/views/app/AppProductOrdersView.vue";
import AppCalendarView from "@/views/app/AppCalendarView.vue";
import AppPlannerView from "@/views/app/AppPlannerView.vue";
import AppContactSupportView from "@/views/app/AppContactSupportView.vue";
import AppSubjectTemplatesView from "@/views/app/AppSubjectTemplatesView.vue";
import AppAssessmentsView from "@/views/app/AppAssessmentsView.vue";
import AppProductsView from "@/views/app/AppProductsView.vue";
import AppCommunicationsView from "@/views/app/AppCommunicationsView.vue";

import AdminLandingView from "@/views/admin/AdminLandingView.vue";
import AdminReportingView from "@/views/admin/AdminReportingView.vue";
import AdminSubjectsView from "@/views/admin/AdminSubjectsView.vue";
import AdminHolidaysView from "@/views/admin/AdminHolidaysView.vue";
import AdminProductsView from "@/views/admin/AdminProductsView.vue";
import AdminProductBundlesView from "@/views/admin/AdminProductBundlesView.vue";
import AdminProductOrdersView from "@/views/admin/AdminProductOrdersView.vue";
import AdminProductOrderQuotesView from "@/views/admin/AdminProductOrderQuotesView.vue";
import AdminTermsView from "@/views/admin/AdminTermsView.vue";
import AdminSchoolsView from "@/views/admin/AdminSchoolsView.vue";
import AdminTaxonomiesView from "@/views/admin/AdminTaxonomiesView.vue";
import AdminSubjectTemplatesView from "@/views/admin/AdminSubjectTemplatesView.vue";
import AdminAssessmentTemplatesView from "@/views/admin/AdminAssessmentTemplatesView.vue";
import AdminAnnouncementsView from "@/views/admin/AdminAnnouncementsView.vue";
import AdminCouponsView from "@/views/admin/AdminCouponsView.vue";
import AdminCommunicationsView from "@/views/admin/AdminCommunicationsView.vue";
import AdminCustomersView from "@/views/admin/AdminCustomersView.vue";
// import AdminTeacherProfilesView from "@/views/admin/AdminTeacherProfilesView.vue";

import WebsiteLandingView from "@/views/website/WebsiteLandingView.vue";
import WebsiteAboutView from "@/views/website/AboutView.vue";
import WebsiteTermsView from "@/views/website/TermsView.vue";
import WebsitePricesView from "@/views/website/PricesView.vue";
//import WebsiteHowItWorksView from "@/views/website/HowItWorksView.vue";
import WebsiteContactUsView from "@/views/website/ContactUsView.vue";
import WebsiteMeetTheTeamView from "@/views/website/MeetTheTeam.vue";

// import DevTestView from '@/views/website/DevTestView.vue';

import PageNotFoundView from "@/views/PageNotFoundView.vue";
// import NotSubscribedView from "@/views/NotSubscribedView.vue";

import { Auth, API } from "aws-amplify";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "WebsiteLanding",
    component: WebsiteLandingView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteLanding" },
  },
  {
    path: "/product/:productId*",
    name: "WebsiteLandingProduct",
    component: WebsiteLandingView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteLandingProduct" },
  },
  {
    path: "/category/:categoryId*",
    name: "WebsiteLandingCategory",
    component: WebsiteLandingView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteLandingCategory" },
  },
  {
    path: "/admin",
    name: "AdminLanding",
    component: AdminLandingView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin", "superadmin"],
      gtm: "AdminLanding",
    },
  },
  {
    path: "/admin/reporting/:report",
    name: "AdminReporting",
    component: AdminReportingView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["reporting"],
      gtm: "AdminReporting",
    },
  },
  {
    path: "/admin/subjects",
    name: "AdminSubjects",
    component: AdminSubjectsView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminSubjects",
    },
  },
  {
    path: "/admin/holidays",
    name: "AdminHolidays",
    component: AdminHolidaysView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminHolidays",
    },
  },
  // {
  //   path: "/admin/customers",
  //   name: "AdminCustomers",
  //   component: AdminCustomersView,
  //   meta: {
  //     layout: AdminLayout,
  //     requiresAuth: true,
  //     allowedGroups: ["admin", "superadmin"],
  //   },
  // },
  {
    path: "/admin/teacherprofiles",
    name: "AdminTeacherProfiles",
    // component: AdminTeacherProfilesView,
    component: AdminCustomersView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin", "superadmin"],
      gtm: "AdminTeacherProfiles",
    },
  },
  {
    path: "/admin/products",
    name: "AdminProducts",
    component: AdminProductsView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminProducts",
    },
  },
  {
    path: "/admin/productbundles",
    name: "AdminProductBundles",
    component: AdminProductBundlesView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminProductBundles",
    },
  },
  {
    path: "/admin/productorder-quotes/customer/:teacherProfileId/:owner/:action*",
    name: "AdminCustomerProductOrderQuotes",
    component: AdminProductOrderQuotesView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminCustomerProductOrderQuotes",
    },
  },
  {
    path: "/admin/productorder-quotes/:orderId*",
    name: "AdminProductOrderQuotes",
    component: AdminProductOrderQuotesView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminProductOrderQuotes",
    },
  },
  {
    path: "/admin/productorders/customer/:teacherProfileId/:owner/:action*",
    name: "AdminCustomerProductOrders",
    component: AdminProductOrdersView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminCustomerProductOrders",
    },
  },
  {
    path: "/admin/productorders/:orderId*",
    name: "AdminProductOrders",
    component: AdminProductOrdersView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminProductOrders",
    },
  },
  {
    path: "/admin/lessontemplates",
    name: "AdminSubjectTemplates",
    component: AdminSubjectTemplatesView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminSubjectTemplates",
    },
  },
  {
    path: "/admin/assessmenttemplates",
    name: "AdminAssessmentTemplates",
    component: AdminAssessmentTemplatesView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminAssessmentTemplates",
    },
  },
  {
    path: "/admin/terms",
    name: "AdminTerms",
    component: AdminTermsView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminTerms",
    },
  },
  {
    path: "/admin/schools",
    name: "AdminSchools",
    component: AdminSchoolsView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminSchools",
    },
  },
  {
    path: "/admin/taxonomies",
    name: "AdminTaxonomies",
    component: AdminTaxonomiesView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminTaxonomies",
    },
  },
  {
    path: "/admin/announcements",
    name: "AdminAnnouncements",
    component: AdminAnnouncementsView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminAnnouncements",
    },
  },
  {
    path: "/admin/coupons",
    name: "AdminCoupons",
    component: AdminCouponsView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminCoupons",
    },
  },
  {
    path: "/admin/communications/:channel*",
    name: "AdminCommunications",
    component: AdminCommunicationsView,
    meta: {
      layout: AdminLayout,
      requiresAuth: true,
      allowedGroups: ["admin"],
      gtm: "AdminCommunications",
    },
  },
  {
    path: "/app",
    name: "AppLanding",
    component: AppLandingView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher", "admin"],
      gtm: "AppLanding",
    },
  },
  {
    path: "/app/profile",
    name: "AppProfile",
    component: AppProfileView,
    meta: { layout: AppLayout, requiresAuth: true, gtm: "AppProfile" },
  },
  {
    path: "/app/communications/:channel*",
    name: "AppCommunications",
    component: AppCommunicationsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppCommunications",
      // allowedGroups: ["teacher", "admin"],
    },
  },
  {
    path: "/app/productorders/:orderId*",
    name: "AppProductOrders",
    component: AppProductOrdersView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppProductOrders",
      // allowedGroups: ["teacher", "admin"],
    },
  },
  {
    path: "/app/calendar",
    name: "AppCalendar",
    component: AppCalendarView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher", "admin"],
      gtm: "AppCalendar",
    },
  },
  {
    path: "/app/lessonplanning",
    name: "AppPlanner",
    component: AppPlannerView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher", "admin"],
      gtm: "AppPlanner",
    },
  },
  {
    path: "/app/support",
    name: "AppSupport",
    component: AppContactSupportView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppSupport",
      // allowedGroups: ["teacher", "admin"],
    },
  },
  {
    path: "/app/lessons",
    name: "AppLessons",
    component: AppSubjectTemplatesView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher", "admin"],
      gtm: "AppLessons",
    },
  },
  {
    path: "/app/assessments",
    name: "AppAssessments",
    component: AppAssessmentsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher", "admin"],
      gtm: "AppAssessments",
    },
  },
  {
    path: "/app/products/category/:categoryId*",
    name: "AppProductsCategory",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppProductsCategory",
      // allowedGroups: ["teacher", "admin"],
    },
  },
  {
    path: "/app/products/:productId/:action*",
    name: "AppProductsAction",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppProductsAction",
      // allowedGroups: ["teacher", "admin"],
    },
  },
  {
    path: "/app/products/:productId*",
    name: "AppProducts",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppProducts",
      // allowedGroups: ["teacher", "admin"],
    },
  },
  {
    path: "/app/purchased-resources/category/:categoryId*",
    name: "AppPurchasedResourcesCategory",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher"],
      gtm: "AppPurchasedResourcesCategory",
    },
  },
  {
    path: "/app/purchased-resources",
    name: "AppPurchasedResources",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher"],
      gtm: "AppPurchasedResources",
    },
  },
  {
    path: "/app/subscribed-products/category/:categoryId*",
    name: "AppSubscribedProductsCategory",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher"],
      gtm: "AppSubscribedProductsCategory",
    },
  },
  {
    path: "/app/subscribed-products",
    name: "AppSubscribedProducts",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      allowedGroups: ["teacher"],
      gtm: "AppSubscribedProducts",
    },
  },
  {
    path: "/app/bought-products/category/:categoryId*",
    name: "AppBoughtProductsCategory",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppBoughtProductsCategory",
      // allowedGroups: ["teacher"],
    },
  },
  {
    path: "/app/bought-products",
    name: "AppBoughtProducts",
    component: AppProductsView,
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      gtm: "AppBoughtProducts",
      // allowedGroups: ["teacher"],
    },
  },
  {
    path: "/app/print/assessment/:templateId",
    name: "AppAssessmentPrinter",
    component: AssessmentPrinter,
    meta: {
      layout: PrintLayout,
      requiresAuth: true,
      allowedGroups: ["teacher", "admin"],
      gtm: "AppAssessmentPrinter",
    },
  },
  {
    path: "/app/print/lesson/:templateId",
    name: "AppLessonPrinter",
    component: LessonPrinter,
    meta: {
      layout: PrintLayout,
      requiresAuth: true,
      allowedGroups: ["teacher", "admin"],
      gtm: "AppLessonPrinter",
    },
  },
  {
    path: "/about",
    name: "WebsiteAbout",
    component: WebsiteAboutView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteAbout" },
  },
  {
    path: "/terms",
    name: "WebsiteTerms",
    component: WebsiteTermsView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteTerms" },
  },
  {
    path: "/contact-us",
    name: "WebsiteContactUs",
    component: WebsiteContactUsView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteContactUs" },
  },
  {
    path: "/prices",
    name: "WebsitePrices",
    component: WebsitePricesView,
    meta: { layout: WebsiteLayout, gtm: "WebsitePrices" },
  },
  // {
  //   path: "/how-it-works",
  //   name: "WebsiteHowItWorks",
  //   component: WebsiteHowItWorksView,
  //   meta: { layout: WebsiteLayout },
  // },
  {
    path: "/meet-the-team",
    name: "WebsiteMeetTheTeam",
    component: WebsiteMeetTheTeamView,
    meta: { layout: WebsiteLayout, gtm: "WebsiteMeetTheTeam" },
  },
  // {
  //   path: '/developer-test',
  //   name: 'DevTest',
  //   component: DevTestView,
  //   meta: { layout: WebsiteLayout }
  // },
  {
    path: "/retrieveuserlogin",
    name: "RetrieveUserLogin",
    component: RetrieveUserLogin,
    meta: { layout: WebsiteLayout, gtm: "RetrieveUserLogin" },
  },
  {
    path: "/login/:email/:password",
    name: "RetrieveUserLoginPassword",
    component: RetrievedUserLogin,
    meta: { layout: WebsiteLayout, gtm: "RetrieveUserLoginPassword" },
  },
  {
    path: "/auth",
    name: "Authenticator",
    component: Authenticator,
    meta: { layout: WebsiteLayout, gtm: "Authenticator" },
  },
  {
    path: "*",
    name: "NotFound",
    component: PageNotFoundView,
    meta: { layout: WebsiteLayout, gtm: "NotFound" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  // console.log("requiresAuth", requiresAuth);
  // console.log("store.state.userSignedIn", store.state.userSignedIn);

  let currentAuthenticatedUser = null;

  if (!requiresAuth) {
    return next();
  } else {
    currentAuthenticatedUser = await Auth
      .currentAuthenticatedUser
      //   {
      //   bypassCache: true,
      // }
      ()
      .catch((error) => {
        // Log any errors
        console.log("error:", error);
      });

    if (!currentAuthenticatedUser)
      return next({
        path: "/auth",
        query: { redirect: to.fullPath },
      });
  }

  try {
    let userGroups = [];

    if (Array.isArray(store.state.userGroups)) {
      userGroups = store.state.userGroups;
    } else {
      // console.log("fetching user groups");

      // const session = await Auth.currentSession();
      let idToken = currentAuthenticatedUser.signInUserSession.getIdToken();
      let groups = idToken.payload["cognito:groups"] || [];

      if (!groups.includes("teacher")) {
        currentAuthenticatedUser = await Auth.currentAuthenticatedUser({
          bypassCache: true,
        }).catch((error) => {
          // Log any errors
          console.log("error:", error);
        });

        idToken = currentAuthenticatedUser.signInUserSession.getIdToken();
        groups = idToken.payload["cognito:groups"] || [];
      }

      if (currentAuthenticatedUser) {
        // console.log("user", user.attributes.email);
        if (!store.state.userSignedIn) {
          store.commit("storeUserSignedIn", true);
          store.commit(
            "storeUserEmail",
            currentAuthenticatedUser.attributes.email
          );
        }
      } else {
        if (store.state.userSignedIn) {
          store.commit("storeUserSignedIn", false);
          store.commit("storeUserEmail", "");
        }
      }

      // console.log("groups", groups);
      userGroups = groups;

      store.commit("storeUserGroups", groups);

      // if (!idTokenPayload) return
      // await API.post("cognitolambdaapi", "/item/listUserGroups", {
      //   body: {
      //     userPoolId: user.pool.userPoolId,
      //     userName: user.username,
      //   },
      // })
      //   .then(async (cognitoListUserGroupsResponse) => {
      //     if (cognitoListUserGroupsResponse.list) {
      //       const newUserGroups = JSON.parse(
      //         cognitoListUserGroupsResponse.list
      //       );
      //       userGroups = newUserGroups;

      //       store.commit("storeUserGroups", newUserGroups);
      //     }
      //   })
      //   .catch((error) => {
      //     // Log any errors
      //     console.log("error:", error);
      //   });
    }

    const allowedGroups = to.meta.allowedGroups || [];

    // if (requiresAuth && !store.state.userSignedIn) {
    //   // Authentication required but not signed in, redirect to the login page
    //   next({
    //     path: "/auth",
    //     query: { redirect: to.fullPath },
    //   });
    // } else
    if (
      // requiresAuth &&
      // store.state.userSignedIn &&
      allowedGroups.length === 0 ||
      userGroups.some((group) => allowedGroups.includes(group))
    ) {
      // User has the required group(s) to access the route
      return next();
    } else {
      // User does not have the required group(s) to access the route
      return next({
        path: "/unauthorised",
      });
    }
  } catch (error) {
    // console.log("error", error)
    // User is not authenticated, redirect to the login page
    return next({
      path: "/auth",
      query: { redirect: to.fullPath },
    });
  }
});

import VueGtm from "@gtm-support/vue2-gtm";

Vue.use(VueGtm, {
  id: [
    "GTM-TGFRHN72",
    // , "G-4JPZRSY7H4", "GT-TXZC2NLG"
  ], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
  queryParams: {
    // // Add url query string when load gtm.js with GTM ID (optional)
    // gtm_auth: 'xxx',
    // gtm_cookies_win: 'x'
  },
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [], // Don't trigger events for specified router names (case insensitive) (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

export default router;
